var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerValueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF5BDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2487 24.1673H17.7487C22.332 24.1673 24.1654 22.334 24.1654 17.7507V12.2507C24.1654 7.66732 22.332 5.83398 17.7487 5.83398H12.2487C7.66536 5.83398 5.83203 7.66732 5.83203 12.2507V17.7507C5.83203 22.334 7.66536 24.1673 12.2487 24.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 17.2818L12.9004 14.4493C13.2121 14.046 13.7896 13.9726 14.1929 14.2843L15.8704 15.6043C16.2737 15.916 16.8512 15.8426 17.1629 15.4485L19.2804 12.7168",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerValueIcon);
export default __webpack_public_path__ + "static/media/CustomerValueIcon.65b70877ae4b52e7718bf63fc5ce5345.svg";
export { ForwardRef as ReactComponent };